import styled from '@emotion/styled';
import { Progress } from '../progress/progress';
import { Typography } from '../typography/typography';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';
import { Spacing } from '../spacing/spacing';

interface LoadingWithTextProps {
  message?: string;
}
export const LoadingWithText = ({
  message = `Please wait while the content is loading`,
}: LoadingWithTextProps) => {
  return (
    <LoaderWrapper>
      <Progress type="circular" indeterminate={true} />
      <ContentWrapper>
        <Spacing marginTop="md">
          <Typography variant="textBodyLargeOnSurfaceVariant">
            {message}
          </Typography>
        </Spacing>
      </ContentWrapper>
    </LoaderWrapper>
  );
};
const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-top: var(--rk-spacing-xl);
  ${mq(BreakpointSizes.desktop)} {
    width: 50%;
    height: 50%;
  }
`;
const ContentWrapper = styled.div`
  margin-top: var(--rk-spacing-sm);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
